<script setup>
defineOptions({
  name: 'MetricCardTitle',
})
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  tooltip: {
    type: String,
    default: '没有提示信息，我怎么开发？'
  }
})
</script>

<template>
  <div class="metric-card-title">
    {{ title }}
    <!-- TODO 2025-06-26 ray: tooltip style 定制？ -->
    <el-tooltip :content="tooltip" placement="right">
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-tips"></use>
      </svg>
    </el-tooltip>
  </div>
</template>

<style scoped lang="scss">
.metric-card-title {
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-text);
  text-align: center;
}

.icon {
  color: var(--color-primary-dark);
}
</style>
